export default {
  ["Дата начала продаж {date}"]: (date?: string) =>
    `Data rozpoczęcia sprzedaży ${date}`,
  ["Закрыть"]: "Zamknij",
  ["Рекламный слайдер"]: "Slider reklamowy",
  ["Используйте клавиши стрелок для переключения слайдов."]:
    "Użyj klawiszy strzałek, aby przełączać slajdy.",
  ["Ещё"]: "Więcej",
  ["Ещё {number}"]: (number?: number) => `${number} więcej`,
  ["Убрать"]: "Usuń",
  ["Меню"]: "Menu",
  ["От {min} до {max} символов"]: (data?: { min: number; max: number }) =>
    `Od ${data?.min} do ${data?.max} znaków`,
  ["Минимум {count} символ"]: (count?: number) => `Minimum ${count} znaków`,
  ["Выбрать из списка"]: "Wybierz z listy",
  ["развернуто"]: "Rozwinięte",
  ["свернуто"]: "Zwinięte",
  ["Модальное окно"]: "Okno modalne",
  ["Выбран"]: "Wybrany",
  ["Не выбран"]: "Nie wybrany",
  ["Свернуть"]: "Zwiń",
  ["Эксклюзив"]: "Ekskluzywne",
  ["Хит продаж"]: "Bestseller",
  ["Новинка"]: "Nowość",
  ["Все книги, получившие эту награду"]:
    "Wszystkie książki, które otrzymały tę nagrodę",
  ["Предыдущий слайд"]: "Poprzedni slajd",
  ["Следующий слайд"]: "Następny slajd",
  ["Оценить книгу на {count} балл из 5"]: (count: number | undefined = 0) =>
    `Oceń książkę na ${count} ${count === 1 ? "punkt" : "punkty"} z 5`,
  ["Снять оценку"]: "Usuń ocenę",
  ["{star} звезда из 5"]: (star: number | undefined = 0) =>
    `${star} ${star === 1 ? "gwiazda" : "gwiazdy"} z 5`,
  ["предыдущий таб"]: "Poprzednia karta",
  ["следующий таб"]: "Następna karta",
};
